module.exports = __webpack_public_path__ + "static/media/mariya-georgieva.4575c40b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/mariya-georgieva.jpg
// module id = 1668
// module chunks = 0